﻿<script setup>
    import {
        requireCanEditCode as vRequireCanEditCode
    } from '@/shared/directives/requirePermission';

    const emit = defineEmits(['onClick']);

    defineProps(
        {
            buttonText: {
                type: String,
                required: true
            },
            libraryName: {
                type: String,
                required: false,
                default: 'Contract'
            }
        });

    function onClick() {
        emit('onClick');
    }

</script>
<template>
    <div class="level">
        <div class="level-left mt-2 mb-3">
            <b-button
                v-require-can-edit-code="{ libraryName }"
                class="is-info"
                @click="onClick">
                <span class="icon is-small">
                    <i class="mdi mdi-plus" />
                </span>
                <span>{{ buttonText }}</span>
            </b-button>
        </div>
    </div>
</template>
